import LocomotiveScroll from 'locomotive-scroll';
const header = document.getElementById('header');
let hidden = false, estatico = true;


const scroll = new LocomotiveScroll({
  el: document.querySelector('[data-scroll-container]'),
  smooth: true,
  getSpeed: true,
  getDirection: true,
});

function invertZIndex(el){
  let zIndex=el.style.zIndex;
  return zIndex*1;
}

function passSlide(el) {
  console.log(el);
}

/* if($('body').hasClass('home')){

  scroll.on('call', (value, way, obj) => {

    if (way === 'enter') {
      const {
        el,
      } = obj
      switch (value) {
        case 'hideProj':
          console.log('aja');
          scroll.scrollTo( document.getElementById('proys'), {
            'offset': 0,
            'duration':0,
            'easing': [0.25, 0.00, 0.35, 1.00],
            'disableLerp': true,
          });
        break;
     }
    }

  });
}
 */
$('.home-project-slide' ).on('wheel', {el: $(this)}, passSlide);

scroll.on('scroll',(instance)=>{
	let headerHeight = header.getBoundingClientRect().height;
if(instance.direction === 'down' && estatico){
  if(instance.scroll.y > headerHeight){
    if($('body').hasClass('single')){
      $('.arrow-down').addClass('enlarge');
      $('.big-image-wrap > div').css('transform', 'scale(1)')
    }

    if($('body').hasClass('home')){
      header.classList.remove('is-inview', 'img-reveal');
    }
	//header.classList.add('pinned');
	estatico = false;
  }
}
if(instance.direction === 'up' && !estatico){
  if(instance.scroll.y <= headerHeight){
	header.classList.remove('pinned');
	if(header.classList.contains('home')){
			header.classList.remove('navbar-dark','bg-dark');
			header.classList.add('navbar-light','bg-light');
		}
		estatico = true;
  }
}

if(instance.direction === 'down' && !hidden){
  if(instance.scroll.y>(headerHeight+200)){
	header.classList.remove('pinned');
	header.classList.add('unpinned');
  hidden = true;
  }
}

if(instance.direction === 'up' && hidden){
  //console.log('show');
  header.classList.remove('unpinned');
  header.classList.add('pinned');
  hidden = false;
}
});


export default {
  init() {
if($('body').hasClass('home')) {
    var options = {
      background: true,
    }
    var iframe = document.querySelector('iframe');
    console.log(iframe);
    var player = new Vimeo.Player(iframe, options);
    player.ready().then(function() {
     let el= document.getElementById('home-img');
     let header= document.getElementById('header');
     let socials= document.getElementById('c-socials');
     let campaign= document.getElementById('c-details');
     let content = document.getElementById('hero-content');
     setTimeout(function(){
      el.classList.add('visible');
      scroll.start();
     }, 2000);

     setTimeout(function(){
      header.classList.add('is-inview');
      content.classList.add('is-inview');
     }, 2200);

     setTimeout(function(){
      socials.classList.add('is-inview');
      campaign.classList.add('is-inview');
     }, 2500);
    });


    player.play().then(function() {
  // The video is playing
  }).catch(function(error) {
  switch (error.name) {
  case 'PasswordError':
      // The video is password-protected
      break;

  case 'PrivacyError':
      // The video is private
      break;

  default:
      // Some other error occurred
      break;
  }
  });

    player.getVideoTitle().then(function(title) {
      console.log('title:', title);
    });

    player.setVolume(0).then(function(volume) {
  // The volume is set
  }).catch(function(error) {
  switch (error.name) {
  case 'RangeError':
      // The volume is less than 0 or greater than 1
      break;

  default:
      // Some other error occurred
      break;
  }
  });

  player.setLoop(true).then(function(loop) {
  // The loop behavior is enabled
  });

  }
    $('.hamburger-menu').click(function(e){
      $('.full-menu').addClass('visible');
      $('.open-menu-overlay').addClass('active');
      e.stopPropagation(); // This is the preferred method.
      return false;        // This should not be used unless you do not want
    })

    $('.close-menu').click(function(){
      $('.full-menu').removeClass('visible');
      $('.open-menu-overlay').removeClass('active');
    });

    $('.open-menu-overlay').click(function() {
      $('.full-menu').removeClass('visible');
      $(this).removeClass('active');
    });

    $(document).on(
      'keydown', function(event) {
        if (event.key == 'Escape') {
          $('.full-menu').removeClass('visible');
          $('.open-menu-overlay').removeClass('active');
        }
    });

    if($('body').hasClass('contacto')){
      $('span.wpcf7-form-control-wrap.archivo input').on('change', function(){
        var file = $(this).val();
        var filename = file.replace(/^.*\\/, '');
        $('.filename').text(filename);
      })
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(window).on('load', function(){
      scroll.update();
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js